export const AskMark = ({ size = 14, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
  >
    <path
      d="M2 12c2.5 0 2.5-3.5 5-3.5S9.5 12 12 12"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M2 7c2.5 0 2.5-3.5 5-3.5S9.5 7 12 7"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.4"
    />
  </svg>
);
